import React from 'react'
import Layout from '../components/Layout/Layout'
import styles from '../style/legal.module.css'
import data from '../data/legal.json'

export default function legal() {
    return (
    <Layout>
        <div className={styles.container}>
            <div className={styles.layout}>
                <div className={styles.wrapper}> 
                    <h1 className="title"><span className="underline">Хууль, журам</span></h1>
                        <table>
                            <tr>
                                <th>№</th>
                                <th>Хууль, тогтоол, хөтөлбөрийн нэр</th>
                                <th>Батлагдсан он, сар, өдөр, дугаар</th>
                                <th>Холбоос</th>
                            </tr>
                            <tr>
                                <th colspan="4" className={styles.center}>Монгол Улсын хууль</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Эрчим хүчний хэмнэлтийн тухай хууль</td>
                                <td>2015.11.26</td>
                                <td><a href="https://www.legalinfo.mn/law/details/11488" target="_blank" rel="noreferrer">Холбоос</a></td>
                            </tr>
                            <tr>
                                <th colspan="4" className={styles.center}>Монгол Улсын Засгийн газрын тогтоол</th>
                            </tr>
                            {data.map(d =>( 
                                <tr>
                                    <td>{d.number}</td>
                                    <td>{d.main}</td>
                                    <td>{d.date}</td>
                                    <td><a href={d.reference} target="_blank" rel="noreferrer">Холбоос</a></td>
                            </tr>
                            ))}
                        </table>
                </div>
            </div>
        </div>
    </Layout>
    )
}
